import {
  EmployeeCount,
  LeadsList,
  WebsiteTraffic,
} from '@mm/state/model/CompanyModel';

export const TEAM_SIZE_LOOKUP = {
  [EmployeeCount.optionOne]: '1-2',
  [EmployeeCount.optionTwo]: '3-14',
  [EmployeeCount.optionThree]: '15-149',
  [EmployeeCount.optionFour]: '150-5000',
};

export const TEAM_SIZE_FROM_BE = {
  '1...2': EmployeeCount.optionOne,
  '3...14': EmployeeCount.optionTwo,
  '15...149': EmployeeCount.optionThree,
  '150...5000': EmployeeCount.optionFour,
};

export const WEBSITE_VISITORS_LOOKUP = {
  [WebsiteTraffic.optionOne]: '0-499',
  [WebsiteTraffic.optionTwo]: '500-4999',
  [WebsiteTraffic.optionThree]: '5000-100000',
};

export const LEAD_LISTS_LOOKUP = {
  [LeadsList.optionOne]: '1-999',
  [LeadsList.optionTwo]: '1000-4999',
  [LeadsList.optionThree]: '5000-100000',
};
